import React from 'react';

import { useParams } from 'react-router-dom';

import { TabulationsDashboard } from './TabulationsDashboard';

export const TabulationsDashboardStandalone: React.FC = () => {
  const { accountId } = useParams();

  if (!accountId) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p className="text-gray-500">No se proporcionó un ID de cuenta</p>
      </div>
    );
  }

  return (
    <div className="w-full h-screen overflow-auto">
      <TabulationsDashboard accountId={Number(accountId)} isStandalone />
    </div>
  );
};
